import React, { useMemo } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import {
  PieChart as RePieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

// Colors for charts
const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#A28FFF",
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
];

// Enhanced mock data with additional fields for richer analysis: gender, incomeBracket, vehicleBrand, lastPurchaseYear
const mockContacts = [
  {
    id: "1",
    name: "Rohan Sharma",
    email: "rohan.sharma@tech-solutions.com",
    vehicleType: "Car",
    age: 35,
    location: "Mumbai",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Maruti Suzuki",
    lastPurchaseYear: 2022,
  },
  {
    id: "2",
    name: "Priya Singh",
    email: "priya.singh@bizcorp.in",
    vehicleType: "Truck",
    age: 42,
    location: "Delhi",
    consent: false,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Tata Motors",
    lastPurchaseYear: 2020,
  },
  {
    id: "3",
    name: "Amit Kumar",
    email: "amit.kumar@motozone.net",
    vehicleType: "Motorcycle",
    age: 28,
    location: "Bangalore",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Royal Enfield",
    lastPurchaseYear: 2023,
  },
  {
    id: "4",
    name: "Deepa Patel",
    email: "deepa.patel@autoexpress.co.in",
    vehicleType: "SUV",
    age: 50,
    location: "Chennai",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Mahindra",
    lastPurchaseYear: 2019,
  },
  {
    id: "5",
    name: "Kunal Gupta",
    email: "kunal.gupta@wheelsindia.org",
    vehicleType: "Car",
    age: 31,
    location: "Hyderabad",
    consent: false,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Hyundai",
    lastPurchaseYear: 2021,
  },
  {
    id: "6",
    name: "Sneha Rao",
    email: "sneha.rao@transportnet.com",
    vehicleType: "Van",
    age: 45,
    location: "Kolkata",
    consent: true,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "Force Motors",
    lastPurchaseYear: 2022,
  },
  {
    id: "7",
    name: "Rahul Reddy",
    email: "rahul.reddy@gearheads.store",
    vehicleType: "Motorcycle",
    age: 22,
    location: "Pune",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Bajaj Auto",
    lastPurchaseYear: 2024,
  },
  {
    id: "8",
    name: "Pooja Joshi",
    email: "pooja.joshi@truckingindia.biz",
    vehicleType: "Truck",
    age: 38,
    location: "Ahmedabad",
    consent: false,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Ashok Leyland",
    lastPurchaseYear: 2018,
  },
  {
    id: "9",
    name: "Sagar Mehta",
    email: "sagar.mehta@carworld.online",
    vehicleType: "Car",
    age: 29,
    location: "Jaipur",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Renault",
    lastPurchaseYear: 2023,
  },
  {
    id: "10",
    name: "Nisha Devi",
    email: "nisha.devi@luxurymotors.co",
    vehicleType: "SUV",
    age: 55,
    location: "Lucknow",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Kia",
    lastPurchaseYear: 2020,
  },
  {
    id: "11",
    name: "Arjun Verma",
    email: "arjun.verma@driveforward.net.in",
    vehicleType: "Car",
    age: 27,
    location: "Surat",
    consent: false,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Volkswagen",
    lastPurchaseYear: 2021,
  },
  {
    id: "12",
    name: "Divya Sharma",
    email: "divya.sharma@logisticshub.in",
    vehicleType: "Truck",
    age: 48,
    location: "Kanpur",
    consent: true,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "SML Isuzu",
    lastPurchaseYear: 2019,
  },
  {
    id: "13",
    name: "Aditya Singh",
    email: "aditya.singh@bikelovers.com",
    vehicleType: "Motorcycle",
    age: 33,
    location: "Nagpur",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "TVS Motor Company",
    lastPurchaseYear: 2022,
  },
  {
    id: "14",
    name: "Meena Reddy",
    email: "meena.reddy@travelvans.org.in",
    vehicleType: "Van",
    age: 40,
    location: "Indore",
    consent: false,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Eicher Motors",
    lastPurchaseYear: 2023,
  },
  {
    id: "15",
    name: "Vikram Gupta",
    email: "vikram.gupta@jeepadventures.net",
    vehicleType: "SUV",
    age: 26,
    location: "Thane",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Jeep",
    lastPurchaseYear: 2024,
  },
  {
    id: "16",
    name: "Kiran Patel",
    email: "kiran.patel@automart.com",
    vehicleType: "Car",
    age: 52,
    location: "Bhopal",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Toyota",
    lastPurchaseYear: 2017,
  },
  {
    id: "17",
    name: "Anjali Desai",
    email: "anjali.desai@trucksales.in",
    vehicleType: "Truck",
    age: 30,
    location: "Visakhapatnam",
    consent: false,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "Mahindra",
    lastPurchaseYear: 2022,
  },
  {
    id: "18",
    name: "Sanjay Kumar",
    email: "sanjay.kumar@riderszone.online",
    vehicleType: "Motorcycle",
    age: 44,
    location: "Pimpri-Chinchwad",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Suzuki Motorcycle India",
    lastPurchaseYear: 2021,
  },
  {
    id: "19",
    name: "Priya Verma",
    email: "priya.verma@carhub.co",
    vehicleType: "Car",
    age: 37,
    location: "Vadodara",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Honda",
    lastPurchaseYear: 2020,
  },
  {
    id: "20",
    name: "Rajesh Sharma",
    email: "rajesh.sharma@suvmarket.biz.in",
    vehicleType: "SUV",
    age: 41,
    location: "Ghaziabad",
    consent: false,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Skoda",
    lastPurchaseYear: 2019,
  },
  {
    id: "21",
    name: "Deepak Rao",
    email: "deepak.rao@vanlifers.net",
    vehicleType: "Van",
    age: 23,
    location: "Ludiana",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Chrysler",
    lastPurchaseYear: 2023,
  },
  {
    id: "22",
    name: "Shruti Gupta",
    email: "shruti.gupta@driveeasy.com",
    vehicleType: "Car",
    age: 39,
    location: "Agra",
    consent: true,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "Maruti Suzuki",
    lastPurchaseYear: 2024,
  },
  {
    id: "23",
    name: "Gopal Singh",
    email: "gopal.singh@haulingco.in",
    vehicleType: "Truck",
    age: 46,
    location: "Nashik",
    consent: false,
    gender: "Male",
    incomeBracket: "High",
    vehicleBrand: "Tata Motors",
    lastPurchaseYear: 2018,
  },
  {
    id: "24",
    name: "Pankaj Kumar",
    email: "pankaj.kumar@bikelegends.org",
    vehicleType: "Motorcycle",
    age: 32,
    location: "Faridabad",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Hero MotoCorp",
    lastPurchaseYear: 2022,
  },
  {
    id: "25",
    name: "Smita Desai",
    email: "smita.desai@exploreauto.online",
    vehicleType: "SUV",
    age: 51,
    location: "Meerut",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Hyundai",
    lastPurchaseYear: 2021,
  },
];

const MarketingAnalysis = ({ contacts = mockContacts }) => {
  // Compute comprehensive analysis data using useMemo for optimization
  const analysisData = useMemo(() => {
    const totalContacts = contacts.length;

    // Consent breakdown
    const consented = contacts.filter((c) => c.consent).length;
    const nonConsented = totalContacts - consented;

    // Helper to get distributions for consented contacts
    const getDistribution = (key) =>
      contacts.reduce((acc, c) => {
        if (c.consent) {
          acc[c[key]] = (acc[c[key]] || 0) + 1;
        }
        return acc;
      }, {});

    // Vehicle type distribution
    const vehicleTypes = getDistribution("vehicleType");

    // Vehicle brand distribution
    const vehicleBrands = getDistribution("vehicleBrand");

    // Age groups
    const ageGroups = {
      "18-25": 0,
      "26-35": 0,
      "36-45": 0,
      "46-55": 0,
      "56+": 0,
    };
    contacts.forEach((c) => {
      if (c.consent) {
        if (c.age <= 25) ageGroups["18-25"]++;
        else if (c.age <= 35) ageGroups["26-35"]++;
        else if (c.age <= 45) ageGroups["36-45"]++;
        else if (c.age <= 55) ageGroups["46-55"]++;
        else ageGroups["56+"]++;
      }
    });

    // Gender distribution
    const genders = getDistribution("gender");

    // Income bracket distribution
    const incomeBrackets = getDistribution("incomeBracket");

    // Location distribution (top 10 for brevity if many)
    const locations = getDistribution("location");
    const topLocations = Object.entries(locations)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 10)
      .reduce((acc, [key, val]) => {
        acc[key] = val;
        return acc;
      }, {});

    // Purchase recency groups (based on current year assumption, e.g., 2024)
    const currentYear = new Date().getFullYear();
    const purchaseRecency = {
      "Recent (Last 1 Year)": 0,
      "1-3 Years Ago": 0,
      "3-5 Years Ago": 0,
      "Over 5 Years Ago": 0,
    };
    contacts.forEach((c) => {
      if (c.consent) {
        const yearsAgo = currentYear - c.lastPurchaseYear;
        if (yearsAgo <= 1) purchaseRecency["Recent (Last 1 Year)"]++;
        else if (yearsAgo <= 3) purchaseRecency["1-3 Years Ago"]++;
        else if (yearsAgo <= 5) purchaseRecency["3-5 Years Ago"]++;
        else purchaseRecency["Over 5 Years Ago"]++;
      }
    });

    // Average age per vehicle type (for insights)
    const avgAgePerType = contacts.reduce((acc, c) => {
      if (c.consent) {
        if (!acc[c.vehicleType]) acc[c.vehicleType] = { sum: 0, count: 0 };
        acc[c.vehicleType].sum += c.age;
        acc[c.vehicleType].count++;
      }
      return acc;
    }, {});
    Object.keys(avgAgePerType).forEach((type) => {
      avgAgePerType[type].avg = (
        avgAgePerType[type].sum / avgAgePerType[type].count
      ).toFixed(1);
    });

    // Consent rate per location (for targeting potential)
    const consentPerLocation = contacts.reduce((acc, c) => {
      if (!acc[c.location]) acc[c.location] = { total: 0, consented: 0 };
      acc[c.location].total++;
      if (c.consent) acc[c.location].consented++;
      return acc;
    }, {});
    Object.keys(consentPerLocation).forEach((loc) => {
      consentPerLocation[loc].rate = (
        (consentPerLocation[loc].consented / consentPerLocation[loc].total) *
        100
      ).toFixed(1);
    });

    return {
      totalContacts,
      consented,
      nonConsented,
      vehicleTypes,
      vehicleBrands,
      ageGroups,
      genders,
      incomeBrackets,
      topLocations,
      purchaseRecency,
      avgAgePerType,
      consentPerLocation,
    };
  }, [contacts]);

  // Helper to convert object to Recharts data array
  const toChartData = (obj) =>
    Object.entries(obj).map(([name, value]) => ({ name, value }));

  // Prepare chart data
  const consentPieData = [
    { name: "Targetable (Consented)", value: analysisData.consented },
    { name: "Non-Targetable (No Consent)", value: analysisData.nonConsented },
  ];

  const vehicleTypeData = toChartData(analysisData.vehicleTypes);
  const vehicleBrandData = toChartData(analysisData.vehicleBrands);
  const ageGroupData = toChartData(analysisData.ageGroups);
  const genderData = toChartData(analysisData.genders);
  const incomeData = toChartData(analysisData.incomeBrackets);
  const locationData = toChartData(analysisData.topLocations);
  const recencyData = toChartData(analysisData.purchaseRecency);

  // For average age bar chart
  const avgAgeData = Object.entries(analysisData.avgAgePerType).map(
    ([name, { avg }]) => ({ name, value: parseFloat(avg) })
  );

  // For consent rate bar chart (top 10 locations for visibility)
  const topConsentRates = Object.entries(analysisData.consentPerLocation)
    .sort((a, b) => b[1].rate - a[1].rate)
    .slice(0, 10)
    .map(([name, { rate }]) => ({ name, value: parseFloat(rate) }));

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Typography variant="h4" gutterBottom>
        Comprehensive Marketing Contacts Analysis
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Total Contacts: {analysisData.totalContacts}
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Targetable vs Non-Targetable
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <RePieChart>
              <Pie
                data={consentPieData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={80}
                fill="#8884d8"
                label
              >
                {consentPieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </RePieChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            You can target {analysisData.consented} contacts who have given
            consent for marketing.
            <br />
            You cannot target {analysisData.nonConsented} contacts without
            consent. Consider strategies to increase consent rates in
            underperforming segments.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Vehicle Type Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={vehicleTypeData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#8884d8" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Focus marketing on popular vehicle types like Cars and SUVs for
            higher reach.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Vehicle Brand Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={vehicleBrandData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#82ca9d" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Target brands like Toyota and Ford owners for partnerships or
            tailored promotions.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Age Group Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={ageGroupData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#ffc658" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Younger groups (26-35) may respond better to digital campaigns,
            while older groups prefer traditional media.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Gender Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <RePieChart>
              <Pie
                data={genderData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={80}
                fill="#8884d8"
                label
              >
                {genderData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </RePieChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Customize messaging based on gender preferences in vehicle
            marketing.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Income Bracket Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={incomeData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#ff7300" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            High-income segments may be targeted for premium vehicle upgrades.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Top Location Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={locationData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#8884d8" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Prioritize geo-targeted ads in high-density areas like New York and
            Chicago.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Purchase Recency Distribution (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={recencyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#82ca9d" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Recent buyers may be open to accessories; older owners to
            maintenance services.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Average Age per Vehicle Type (Targetable)
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={avgAgeData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#ffc658" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Tailor products: Younger motorcycle owners for sporty items, older
            SUV owners for family-oriented features.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Consent Rate per Location (%) - Top 10
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <ReBarChart data={topConsentRates}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" fill="#ff7300" />
            </ReBarChart>
          </ResponsiveContainer>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Locations with high consent rates are ideal for campaigns; low rates
            indicate need for trust-building efforts.
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MarketingAnalysis;
